import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEditPencil = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "border_color_2",
		d: "M1.66675 19.9999V17.4999H18.3334V19.9999H1.66675ZM5.00008 13.6778H6.0305L12.9472 6.77388L12.4232 6.24201L11.904 5.73076L5.00008 12.6474V13.6778ZM3.75008 14.9278V12.1153L13.0915 2.7868C13.2122 2.6661 13.3492 2.57478 13.5026 2.51284C13.6558 2.45089 13.8152 2.41992 13.9809 2.41992C14.1467 2.41992 14.3073 2.45089 14.4626 2.51284C14.6179 2.57478 14.7602 2.67041 14.8895 2.79971L15.8911 3.81409C16.0204 3.93478 16.1139 4.07305 16.1715 4.22888C16.2292 4.38457 16.258 4.54555 16.258 4.7118C16.258 4.86763 16.2288 5.02256 16.1703 5.17659C16.1118 5.33076 16.0188 5.47166 15.8911 5.5993L6.56258 14.9278H3.75008ZM12.9472 6.77388L12.4232 6.24201L11.904 5.73076L12.9472 6.77388Z",
		fill: "currentColor"
	})
});
export default SvgEditPencil;
